import React, { FC } from "react";
import FlexLine from "../../../../../components/elements/flexLine/FlexLine";
import { IWorkDash, WorkDisplayPeriod } from "@baseTypes/service/dashboard/IWorksDashboardService";
import st from './WorkItem.module.scss';
import WorkItemTitle from "@pages/dashboard/works/components/WorkItem/WorkItemTitle/WorkItemTitle";
import WorkItemBars from "@pages/dashboard/works/components/WorkItem/WorkItemBars/WorkItemBars";
import WorkItemArea from "@pages/dashboard/works/components/WorkItem/WorkItemArea/WorkItemArea";
import { PartialFields } from "@utils/typeUtils";
import cn from 'classnames';
import { isNil } from "lodash";
import { StatusCodeNames } from "../../../../../store/reducers/dashboard/vehicles/statuses/types";

type Excluded = 'period' | 'workId' | 'cropRotationIds' | 'geoZoneCultivationInfo' | 'color' | 'unitIds'
type Work = PartialFields<IWorkDash, Excluded>

export type Status = {
    name: string
    color: string
    value: number
    statusCode: StatusCodeNames
}

export type WorkItemVariant = 'extended' | 'default'

type WorkItemProps = {
    work: Work
    listWrapperRef?: React.RefObject<HTMLDivElement | null>
    onTitleClick?: () => void
    onBarClick?: (period: WorkDisplayPeriod) => void
    style?: React.CSSProperties
    type?: 'group' | 'item'
    barsWidth?: number
    statuses?: Status[]
    statusesLoading?: boolean
}

const WorkItem: FC<WorkItemProps> = (props) => {
    const {
        work,
        listWrapperRef,
        onTitleClick,
        onBarClick,
        style,
        type = 'item',
        barsWidth,
        statuses,
        statusesLoading
    } = props;

    const variant: WorkItemVariant = !isNil(statuses) ? 'extended' : 'default';

    const { displayName, season, today, color } = work;
    const averageSeason = (season.cultivatedArea / (season.totalArea || 1)) * 100;
    const averageToday = (today.cultivatedArea / (today.totalArea || 1)) * 100;

    return (
        <FlexLine className={cn(st['work__line'], st[`work__line--${type}`], st[`work__line--${variant}`])} style={style}>
            <WorkItemTitle color={color}
                           displayName={displayName}
                           onClick={onTitleClick}
                           maxLines={variant === 'extended' ? 3 : 2} />
            <WorkItemBars width={barsWidth}
                          variant={variant}
                          period={work.period?.plan}
                          season={season}
                          statusesLoading={statusesLoading}
                          statuses={statuses}
                          averageSeason={averageSeason}
                          today={today}
                          averageToday={averageToday}
                          listWrapperRef={listWrapperRef}
                          onClick={onBarClick} />
            <WorkItemArea season={season} today={today} />
        </FlexLine>
    );
}

export default WorkItem;